module.exports = __webpack_public_path__ + "static/media/editor-icon-text-more-active.5f92db7b.svg";